<template>
    <section :class="{'CategoryFilterSection': true, 'is-open': true, 'CategoryFilterSection--productSeries': productSeries}">
        <div class="CategoryFilterSection-heading">
            <span v-if="attributeSection" class="CategoryFilterSection-icon">
                <component :is="resolveIconForAttributeSection()"/>
            </span>
            <h3 class="CategoryFilterSection-title">{{ section.title }}</h3>
        </div>
        <div class="CategoryFilterSection-collapsable">
            <component :is="controlType"
                       v-for="(control, index) in section.data"
                       :key="control.name ?? control.nameMin"
                       :data="control"
                       :hidden="!allVisible && index >= visibleCount"/>
            <span class="CategoryFilterSection-more" @click="toggleVisibility()" v-if="getHiddenCount()">
                {{ allVisible ? showLessLabel : `${showMoreLabel} (${getHiddenCount()})` }}
            </span>
        </div>
    </section>
</template>

<script lang="ts">
import {defineComponent, Ref, ref} from "vue";
import FilterSlide from "./FilterSlide.vue";
import FilterCheck from "./FilterCheck.vue";
import {FilterCheckData} from "@/types";
import {mapGetters} from "vuex";
import IconProductSeries from "@/icons/IconProductSeries.vue";
import IconSkincareStep from "@/icons/IconSkincareStep.vue";
import IconPackage from "@/icons/IconPackage.vue";
import IconProcedure from "@/icons/IconProcedure.vue";
import IconParameter from "@/icons/IconParameter.vue";

export default defineComponent({
    name: "FilterSection",
    components: {
        FilterSlide,
        FilterCheck,
    },
    computed: mapGetters({
        showLessLabel: 'getShowLessLabel',
        showMoreLabel: 'getShowMoreLabel'
    }),
    props: {
        section: {
            type: Object,
            required: true
        }
    },
    setup(props) {
        // Zadrátovaná entityId posílaná z BE.
        const PRODUCT_SERIES_ATTRIBUTE_IDENTIFIER = 11;
        const SKINCARE_STEP_ATTRIBUTE_IDENTIFIER = 14;
        const PROCEDURE_ATTRIBUTE_IDENTIFIER = 13;
        const PACKAGE_ATTRIBUTE_IDENTIFIER = 12;

        const controlType = props.section.type === 'slide' ? FilterSlide : FilterCheck,
            visibleCount: Ref<number> = ref(5);
        const attributeSection = typeof props.section.identifier !== "undefined"; // Pro atributy se posílá identifier atributu.
        const productSeries = attributeSection && props.section.identifier === PRODUCT_SERIES_ATTRIBUTE_IDENTIFIER;

        let allVisible: Ref<boolean> = ref(false);

        const toggleVisibility = (): void => {
            allVisible.value = !allVisible.value;
        };

        const getHiddenCount = (): number => {
            return props.section.data.filter((check: FilterCheckData, index: number) => {
                return index >= visibleCount.value && !check.checked;
            }).length;
        }

        const resolveIconForAttributeSection = () => {
            const id = props.section.identifier;
            if (id === PRODUCT_SERIES_ATTRIBUTE_IDENTIFIER) {
                return IconProductSeries;
            } else if (id === SKINCARE_STEP_ATTRIBUTE_IDENTIFIER) {
                return IconSkincareStep;
            } else if (id === PROCEDURE_ATTRIBUTE_IDENTIFIER) {
                return IconProcedure;
            } else if (id === PACKAGE_ATTRIBUTE_IDENTIFIER) {
                return IconPackage;
            }

            return IconParameter;
        }

        return {
            controlType,
            visibleCount,
            attributeSection,
            productSeries,

            allVisible,
            toggleVisibility,
            getHiddenCount,
            resolveIconForAttributeSection,
        }
    }
});
</script>
